import React from 'react';
import Modal from '@/UIlibrary/Modal/Modal';
import Button from '@/UIlibrary/Button/Button';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { useTranslations } from 'use-intl';

interface ConfirmModalProps {
	isOpen: boolean;
	title: string;
	subtitle?: string;
	confirmActionText?: string;
	children?: React.ReactNode;
	onConfirm?: () => void;
	onCancel?: () => void;
	onClose: () => void;
	type?: 'delete' | 'confirm';
	cancelBtnTestId?: string;
	confirmBtnTestId?: string;
	maxWidth?: number;
	cancelBtnLoading?: boolean;
	confirmBtnLoading?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
	isOpen,
	title,
	subtitle,
	confirmActionText = 'Confirm',
	children,
	onConfirm,
	onCancel,
	onClose,
	type = 'confirm',
	cancelBtnTestId,
	confirmBtnTestId,
	maxWidth = 400,
	cancelBtnLoading,
	confirmBtnLoading
}) => {
	const t = useTranslations('ConfirmModal');
	return (
		<Modal isOpen={isOpen} closeable onClose={onClose} maxWidth={maxWidth}>
			<Typography weight="semibold">{title}</Typography>
			<div className="flex flex-col justify-start mt-6 gap-2">
				<Typography weight="medium" color="subtitle">
					{subtitle}
				</Typography>
				<Typography weight="medium">{children}</Typography>
			</div>
			<div className="flex flex-col md:flex-row md:space-x-8 mt-8 ">
				<div className="w-full my-4 md:my-0 ">
					<Button
						size="full"
						color="gray"
						onClick={onCancel}
						label={t('Cancel')}
						dataTestId={cancelBtnTestId || 'cancelBtn'}
						loading={cancelBtnLoading}
					/>
				</div>
				<div className="w-full">
					<Button
						size="full"
						color={type === 'delete' ? 'error' : 'primary'}
						onClick={onConfirm}
						label={confirmActionText}
						dataTestId={confirmBtnTestId || 'confirmBtn'}
						loading={confirmBtnLoading}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default ConfirmModal;
